import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  SimpleGrid,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import axiosInstance from "../../../../helpers/api";
import { getAllChaptersRequest } from "../../../../modules/admin-modules/chapters/Actions";
import { getAllLecturesRequest } from "../../../../modules/admin-modules/lectures/Actions";
import { closeCreatePaymentModel } from "../../../../modules/admin-modules/models/Actions";
import { studentPerformanceRequest } from "../../../../modules/admin-modules/reports/Actions";
import { getPaymentSubjectRequest } from "../../../../modules/admin-modules/videos/Actions";

const C = {
  primary: "#6A1E1E",
  secondary: "#4A0F1F",
  border: "#D8CEC3",
  muted: "rgba(74, 15, 31, 0.65)",
};

const colourStyles = {
  control: (styles, state) => ({
    ...styles,
    width: "100%",
    backgroundColor: "#FAF2EB",
    color: "#1e1b17",
    borderRadius: "12px",
    borderColor: state.isFocused ? "#6A1E1E" : "#D8CEC3",
    borderWidth: "1px",
    boxShadow: state.isFocused ? "0 0 0 1px rgba(106, 30, 30, 0.22)" : "none",
    minHeight: "42px",
    ":hover": {
      borderColor: "#6A1E1E",
    },
  }),
  indicatorSeparator: () => ({ display: "none" }),
  placeholder: (styles) => ({
    ...styles,
    color: "#D8CEC3",
    fontWeight: 600,
    fontSize: "14px",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#1e1b17",
    fontWeight: 600,
    fontSize: "14px",
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "rgba(106, 30, 30, 0.12)",
    borderRadius: "8px",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#4A0F1F",
    fontWeight: 600,
    fontSize: "13px",
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: "12px",
    overflow: "hidden",
    border: "1px solid #D8CEC3",
    boxShadow: "0 16px 40px rgba(74, 15, 31, 0.18)",
    zIndex: 50,
  }),
  option: (styles, state) => ({
    ...styles,
    fontSize: "14px",
    fontWeight: state.isSelected ? 800 : 600,
    color: state.isSelected ? "#E9E2DB" : "#4A0F1F",
    backgroundColor: state.isSelected
      ? "#4A0F1F"
      : state.isFocused
        ? "rgba(233, 226, 219, 0.7)"
        : "transparent",
    ":active": {
      backgroundColor: "rgba(216, 206, 195, 0.7)",
    },
  }),
};

const AddPayment = ({ selectedData, setSelectedData }) => {
  const dispatch = useDispatch();
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);
  const chapters = useSelector((state) => state.chapters.chapters);
  const lectures = useSelector((state) => state.lectures.lectures);
  const openEvent = useSelector((state) => state.model.isOpen19);
  const studentPerformance = useSelector((state) => state.reports.performance);

  const [isLoading, setLoading] = useState(false);

  const lecturesOptions = lectures?.map((d) => ({ value: d.id, label: d.title }));
  const paymentsOptions = paymentSubjects?.map((d) => ({ value: d.id, label: d.name }));
  const chaptersOptions = chapters?.map((d) => ({ value: d.id, label: d.name }));

  useEffect(() => {
    if (openEvent) {
      dispatch(getPaymentSubjectRequest());
      dispatch(getAllLecturesRequest());
      dispatch(getAllChaptersRequest());
      if (selectedData?.id) {
        dispatch(studentPerformanceRequest(selectedData.id));
      }
    }
  }, [openEvent, selectedData?.id, dispatch]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {},
    shouldUnregister: true,
  });

  const isPaidChecked = !!watch("is_paid");

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color="#6A1E1E"
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        Payment & attendance
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="rgba(74, 15, 31, 0.6)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        Record attendance, session, and payment for this student
      </Text>
    </Box>
  );

  const onSubmit = (data) => {
    const chapter_ids = (data?.chapter_ids || []).map((v) => v?.value).filter(Boolean);
    const { chapter_ids: _chapterSelect, ...rest } = data;
    const body = {
      ...rest,
      attend: data?.attend ? "1" : "0",
      is_paid: !!data?.is_paid,
      user_id: selectedData?.id,
      chapter_ids,
      video_exception: 1,
      is_center: 0,
    };
    const action = () => {
      dispatch(closeCreatePaymentModel());
      setSelectedData({});
      reset();
      toast.success("Payment recorded successfully.");
      setLoading(false);
    };

    setLoading(true);
    axiosInstance
      .post(`/admin/attendence/scan`, body)
      .then(() => {
        action();
      })
      .catch((err) => {
        toast?.error(err?.response?.data?.message || err?.message);
        setLoading(false);
      });
  };

  const closeFunc = () => {
    dispatch(closeCreatePaymentModel());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openEvent}
      buttonTitle={null}
      buttonFunc={handleSubmit(onSubmit)}
      size="4xl"
      contentProps={{
        dir: "ltr",
        bg: "#E9E2DB",
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "2xl",
      }}
      headerProps={{
        px: 8,
        pt: 8,
        pb: 6,
        borderBottom: "1px solid rgba(216, 206, 195, 0.5)",
      }}
      bodyProps={{ px: 8, py: 8, maxH: "80vh", overflowY: "auto" }}
      hideDefaultFooter
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={6} dir="ltr" w="100%">
          <Flex
            align={{ base: "stretch", md: "flex-start" }}
            justify="space-between"
            gap={6}
            flexDir={{ base: "column", md: "row" }}
            flexWrap="wrap"
          >
            <Stack direction="row" spacing={6} align="center" flexWrap="wrap">
              <Checkbox
                {...register("attend")}
                colorScheme="red"
                borderColor={C.border}
                fontWeight="600"
                color={C.secondary}
              >
                Attended
              </Checkbox>
              <Checkbox
                {...register("is_paid")}
                colorScheme="red"
                borderColor={C.border}
                fontWeight="600"
                color={C.secondary}
              >
                Paid
              </Checkbox>
            </Stack>

            {studentPerformance?.payment && studentPerformance.payment.length > 0 ? (
              <Box flex="1" minW={{ base: "100%", md: "280px" }} maxW="420px">
                <Accordion allowToggle defaultIndex={[]}>
                  <AccordionItem border="1px solid" borderColor={C.border} borderRadius="12px" bg="rgba(255,255,255,0.5)">
                    <AccordionButton
                      borderRadius="12px"
                      py={3}
                      px={4}
                      _expanded={{ bg: "rgba(106, 30, 30, 0.08)", color: C.primary }}
                      _hover={{ bg: "rgba(106, 30, 30, 0.05)" }}
                    >
                      <Box flex="1" textAlign="left" fontSize="sm" fontWeight="700">
                        Previous payments
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel pb={4} px={3}>
                      <TableContainer>
                        <Table size="sm" variant="simple">
                          <Thead>
                            <Tr>
                              <Th fontSize="xs" p={2} color={C.muted}>
                                Subject
                              </Th>
                              <Th fontSize="xs" p={2} color={C.muted}>
                                Paid
                              </Th>
                              <Th fontSize="xs" p={2} color={C.muted}>
                                Remaining
                              </Th>
                              <Th fontSize="xs" p={2} color={C.muted}>
                                Date
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {studentPerformance.payment.map((paymentItem) => (
                              <Tr key={paymentItem.id}>
                                <Td fontSize="xs" p={2}>
                                  {paymentItem.payment_subject?.name || "—"}
                                </Td>
                                <Td fontSize="xs" p={2} color="green.600" fontWeight="600">
                                  {paymentItem.paid_amount} EGP
                                </Td>
                                <Td
                                  fontSize="xs"
                                  p={2}
                                  color={paymentItem.remaining_amount > 0 ? "red.600" : "green.600"}
                                  fontWeight="600"
                                >
                                  {paymentItem.remaining_amount} EGP
                                </Td>
                                <Td fontSize="xs" p={2}>
                                  {new Date(paymentItem.created_at).toLocaleDateString()}
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              </Box>
            ) : null}
          </Flex>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={8} spacingY={6} alignItems="start">
            <FormControl gridColumn={{ base: "auto", md: "1 / -1" }}>
              <VStack align="stretch" spacing={2}>
                <FormLabel m={0} fontSize="14px" fontWeight="700" color={C.primary} textAlign="left">
                  Session / attendance location
                </FormLabel>
                <Select
                  inputId="lec_id"
                  options={lecturesOptions}
                  onChange={(d) => setValue("lec_id", d.value)}
                  styles={colourStyles}
                  placeholder="Select lecture or center session"
                />
              </VStack>
            </FormControl>

            <MainInput
              label="Attendance or payment date"
              error={errors?.created_at?.message}
              register={register}
              name="created_at"
              type="datetime-local"
            />

            <FormControl gridColumn={{ base: "auto", md: "1 / -1" }}>
              <VStack align="stretch" spacing={2}>
                <FormLabel m={0} fontSize="14px" fontWeight="700" color={C.primary} textAlign="left">
                  Chapters
                </FormLabel>
                <Select
                  inputId="chapter_ids"
                  isMulti
                  options={chaptersOptions}
                  onChange={(d) => setValue("chapter_ids", d || [])}
                  styles={colourStyles}
                  placeholder="Select one or more chapters"
                />
              </VStack>
            </FormControl>

            {isPaidChecked ? (
              <>
                <MainInput
                  label="Paid amount"
                  error={errors?.paid_amount?.message}
                  register={register}
                  name="paid_amount"
                  type="number"
                />
                <FormControl>
                  <VStack align="stretch" spacing={2}>
                    <FormLabel m={0} fontSize="14px" fontWeight="700" color={C.primary} textAlign="left">
                      Payment type
                    </FormLabel>
                    <Select
                      inputId="payment_subject_id"
                      options={paymentsOptions}
                      onChange={(d) => setValue("payment_subject_id", d.value)}
                      styles={colourStyles}
                      placeholder="Select payment subject"
                    />
                  </VStack>
                </FormControl>
                <MainInput
                  label="Remaining amount"
                  error={errors?.remaining_amount?.message}
                  register={register}
                  name="remaining_amount"
                  type="number"
                  required={false}
                />
              </>
            ) : null}

            <Box gridColumn={{ base: "auto", md: "1 / -1" }}>
              <MainInput
                label="Comment"
                error={errors?.comment?.message}
                register={register}
                name="comment"
                type="text"
                required={false}
              />
            </Box>
          </SimpleGrid>

          <Flex justify="flex-end" gap={6} pt={4}>
            <Button
              variant="ghost"
              color="#4A0F1F"
              fontWeight="800"
              _hover={{ textDecoration: "underline" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg="#6A1E1E"
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: "#4A0F1F" }}
              boxShadow="0 10px 24px rgba(106, 30, 30, 0.18)"
            >
              Save changes
            </Button>
          </Flex>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddPayment;
